export const routes = [
  {
    path: '/:all(.*)',
    name: '404',
    component: () => import('D:/BJProject/frontend_okok/src/pages/[...all].vue'),
    /* no children */
  },
  {
    path: '/account-center',
    /* internal name: '/account-center' */
    /* no component */
    children: [
      {
        path: '',
        name: 'AccountCenter',
        component: () => import('D:/BJProject/frontend_okok/src/pages/account-center/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/activity',
    /* internal name: '/activity' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Activity',
        component: () => import('D:/BJProject/frontend_okok/src/pages/activity/index.vue'),
        /* no children */
      },
      {
        path: 'details',
        /* internal name: '/activity/details' */
        /* no component */
        children: [
          {
            path: 'acti-info',
            name: 'acti-info',
            component: () => import('D:/BJProject/frontend_okok/src/pages/activity/details/acti-info.vue'),
            /* no children */
          },
          {
            path: 'acti-info-five',
            name: '/activity/details/acti-info-five',
            component: () => import('D:/BJProject/frontend_okok/src/pages/activity/details/acti-info-five.vue'),
            /* no children */
          },
          {
            path: 'acti-info-four',
            name: 'acti-info-four',
            component: () => import('D:/BJProject/frontend_okok/src/pages/activity/details/acti-info-four.vue'),
            /* no children */
          },
          {
            path: 'acti-info-six',
            name: '/activity/details/acti-info-six',
            component: () => import('D:/BJProject/frontend_okok/src/pages/activity/details/acti-info-six.vue'),
            /* no children */
          },
          {
            path: 'acti-info-three',
            name: 'acti-info-three',
            component: () => import('D:/BJProject/frontend_okok/src/pages/activity/details/acti-info-three.vue'),
            /* no children */
          },
          {
            path: 'acti-info-two',
            name: 'acti-info-two',
            component: () => import('D:/BJProject/frontend_okok/src/pages/activity/details/acti-info-two.vue'),
            /* no children */
          },
          {
            path: 'Bonus-de-novo-jogador',
            name: 'Bonus-de-novo-jogador',
            component: () => import('D:/BJProject/frontend_okok/src/pages/activity/details/Bonus-de-novo-jogador.vue'),
            /* no children */
          },
          {
            path: 'taxt-de-info',
            name: 'taxt-de-info',
            component: () => import('D:/BJProject/frontend_okok/src/pages/activity/details/taxt-de-info.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/agent',
    /* internal name: '/agent' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Agent',
        component: () => import('D:/BJProject/frontend_okok/src/pages/agent/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/betting-history',
    /* internal name: '/betting-history' */
    /* no component */
    children: [
      {
        path: '',
        name: 'BettingHistory',
        component: () => import('D:/BJProject/frontend_okok/src/pages/betting-history/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/carteira',
    /* internal name: '/carteira' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Carteira',
        component: () => import('D:/BJProject/frontend_okok/src/pages/carteira/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/change-password',
    /* internal name: '/change-password' */
    /* no component */
    children: [
      {
        path: '',
        name: 'ChangePassword',
        component: () => import('D:/BJProject/frontend_okok/src/pages/change-password/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/charts',
    /* internal name: '/charts' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Charts',
        component: () => import('D:/BJProject/frontend_okok/src/pages/charts/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/check-in',
    /* internal name: '/check-in' */
    /* no component */
    children: [
      {
        path: '',
        name: 'CheckIn',
        component: () => import('D:/BJProject/frontend_okok/src/pages/check-in/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/counter',
    /* internal name: '/counter' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Counter',
        component: () => import('D:/BJProject/frontend_okok/src/pages/counter/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/deposit-history',
    /* internal name: '/deposit-history' */
    /* no component */
    children: [
      {
        path: '',
        name: 'DepositHistory',
        component: () => import('D:/BJProject/frontend_okok/src/pages/deposit-history/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/dispositivo',
    /* internal name: '/dispositivo' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Dispositivo',
        component: () => import('D:/BJProject/frontend_okok/src/pages/dispositivo/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/forgot-password',
    /* internal name: '/forgot-password' */
    /* no component */
    children: [
      {
        path: '',
        name: 'ForgotPassword',
        component: () => import('D:/BJProject/frontend_okok/src/pages/forgot-password/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/games',
    /* internal name: '/games' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Games',
        component: () => import('D:/BJProject/frontend_okok/src/pages/games/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/home',
    /* internal name: '/home' */
    /* no component */
    children: [
      {
        path: '/',
        name: 'Home',
        component: () => import('D:/BJProject/frontend_okok/src/pages/home/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/keepalive',
    /* internal name: '/keepalive' */
    /* no component */
    children: [
      {
        path: '',
        name: 'KeepAlive',
        component: () => import('D:/BJProject/frontend_okok/src/pages/keepalive/index.vue'),
        /* no children */
        meta: {
          "keepAlive": true
        },
      }
    ],
  },
  {
    path: '/mail',
    /* internal name: '/mail' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Mail',
        component: () => import('D:/BJProject/frontend_okok/src/pages/mail/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/messages',
    /* internal name: '/messages' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Messages',
        component: () => import('D:/BJProject/frontend_okok/src/pages/messages/index.vue'),
        /* no children */
      },
      {
        path: 'details',
        /* internal name: '/messages/details' */
        /* no component */
        children: [
          {
            path: 'Details',
            name: 'MessageDetails',
            component: () => import('D:/BJProject/frontend_okok/src/pages/messages/details/Details.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/nickname',
    /* internal name: '/nickname' */
    /* no component */
    children: [
      {
        path: '',
        name: 'nickname',
        component: () => import('D:/BJProject/frontend_okok/src/pages/nickname/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/profile',
    /* internal name: '/profile' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Profile',
        component: () => import('D:/BJProject/frontend_okok/src/pages/profile/index.vue'),
        /* no children */
      },
      {
        path: 'seguranca',
        /* internal name: '/profile/seguranca' */
        /* no component */
        children: [
          {
            path: '',
            name: 'Seguranca',
            component: () => import('D:/BJProject/frontend_okok/src/pages/profile/seguranca/index.vue'),
            /* no children */
          },
          {
            path: 'details',
            /* internal name: '/profile/seguranca/details' */
            /* no component */
            children: [
              {
                path: 'EMail',
                name: 'EMail',
                component: () => import('D:/BJProject/frontend_okok/src/pages/profile/seguranca/details/EMail.vue'),
                /* no children */
              },
              {
                path: 'Google',
                name: 'Google',
                component: () => import('D:/BJProject/frontend_okok/src/pages/profile/seguranca/details/Google.vue'),
                /* no children */
              },
              {
                path: 'Name',
                name: 'Name',
                component: () => import('D:/BJProject/frontend_okok/src/pages/profile/seguranca/details/Name.vue'),
                /* no children */
              },
              {
                path: 'Pergunta',
                name: 'Pergunta',
                component: () => import('D:/BJProject/frontend_okok/src/pages/profile/seguranca/details/Pergunta.vue'),
                /* no children */
              },
              {
                path: 'SenhaLogin',
                name: 'SenhaLogin',
                component: () => import('D:/BJProject/frontend_okok/src/pages/profile/seguranca/details/SenhaLogin.vue'),
                /* no children */
              },
              {
                path: 'SenhaSaque',
                name: 'SenhaSaque',
                component: () => import('D:/BJProject/frontend_okok/src/pages/profile/seguranca/details/SenhaSaque.vue'),
                /* no children */
              },
              {
                path: 'Telefone',
                name: 'Telefone',
                component: () => import('D:/BJProject/frontend_okok/src/pages/profile/seguranca/details/Telefone.vue'),
                /* no children */
              },
              {
                path: 'ThreeParties',
                name: 'ThreeParties',
                component: () => import('D:/BJProject/frontend_okok/src/pages/profile/seguranca/details/ThreeParties.vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'user-info',
        /* internal name: '/profile/user-info' */
        /* no component */
        children: [
          {
            path: '',
            name: 'UserInfo',
            component: () => import('D:/BJProject/frontend_okok/src/pages/profile/user-info/index.vue'),
            /* no children */
          },
          {
            path: 'avatar',
            /* internal name: '/profile/user-info/avatar' */
            /* no component */
            children: [
              {
                path: '',
                name: 'Avatar',
                component: () => import('D:/BJProject/frontend_okok/src/pages/profile/user-info/avatar/index.vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/promocao',
    /* internal name: '/promocao' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Promocao',
        component: () => import('D:/BJProject/frontend_okok/src/pages/promocao/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/Registros',
    /* internal name: '/Registros' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Registros',
        component: () => import('D:/BJProject/frontend_okok/src/pages/Registros/index.vue'),
        /* no children */
      },
      {
        path: 'ContaDetails',
        /* internal name: '/Registros/ContaDetails' */
        /* no component */
        children: [
          {
            path: 'ContaDetails',
            name: 'ContaDetails',
            component: () => import('D:/BJProject/frontend_okok/src/pages/Registros/ContaDetails/ContaDetails.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/Saque',
    /* internal name: '/Saque' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Saque',
        component: () => import('D:/BJProject/frontend_okok/src/pages/Saque/index.vue'),
        /* no children */
      },
      {
        path: 'details',
        /* internal name: '/Saque/details' */
        /* no component */
        children: [
          {
            path: 'saquesDetails',
            name: 'SaquesDetails',
            component: () => import('D:/BJProject/frontend_okok/src/pages/Saque/details/saquesDetails.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/SaqueSetting',
    /* internal name: '/SaqueSetting' */
    /* no component */
    children: [
      {
        path: '',
        name: 'SaqueSetting',
        component: () => import('D:/BJProject/frontend_okok/src/pages/SaqueSetting/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/scroll-cache',
    /* internal name: '/scroll-cache' */
    /* no component */
    children: [
      {
        path: '',
        name: 'ScrollCache',
        component: () => import('D:/BJProject/frontend_okok/src/pages/scroll-cache/index.vue'),
        /* no children */
        meta: {
          "keepAlive": true
        },
      }
    ],
  },
  {
    path: '/settings',
    /* internal name: '/settings' */
    /* no component */
    children: [
      {
        path: '',
        name: 'Settings',
        component: () => import('D:/BJProject/frontend_okok/src/pages/settings/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/test',
    /* internal name: '/test' */
    /* no component */
    children: [
      {
        path: '',
        name: 'test',
        component: () => import('D:/BJProject/frontend_okok/src/pages/test/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/transaction-password',
    /* internal name: '/transaction-password' */
    /* no component */
    children: [
      {
        path: '',
        name: 'TransactionPassword',
        component: () => import('D:/BJProject/frontend_okok/src/pages/transaction-password/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/unocss',
    /* internal name: '/unocss' */
    /* no component */
    children: [
      {
        path: '',
        name: 'UnoCSS',
        component: () => import('D:/BJProject/frontend_okok/src/pages/unocss/index.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/vendorearch',
    /* internal name: '/vendorearch' */
    /* no component */
    children: [
      {
        path: '',
        name: 'vendorearch',
        component: () => import('D:/BJProject/frontend_okok/src/pages/vendorearch/index.vue'),
        /* no children */
      },
      {
        path: 'details',
        /* internal name: '/vendorearch/details' */
        /* no component */
        children: [
          {
            path: 'testsearch',
            name: 'testsearch',
            component: () => import('D:/BJProject/frontend_okok/src/pages/vendorearch/details/testsearch.vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/withdrawal-history',
    /* internal name: '/withdrawal-history' */
    /* no component */
    children: [
      {
        path: '',
        name: 'WithdrawalHistory',
        component: () => import('D:/BJProject/frontend_okok/src/pages/withdrawal-history/index.vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router, _hotUpdateCallback) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
    import.meta.hot.data.router_hotUpdateCallback = _hotUpdateCallback
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    // call the hotUpdateCallback for custom updates
    import.meta.hot.data.router_hotUpdateCallback?.(mod.routes)
    const route = router.currentRoute.value
    router.replace({
      ...route,
      // NOTE: we should be able to just do ...route but the router
      // currently skips resolving and can give errors with renamed routes
      // so we explicitly set remove matched and name
      name: undefined,
      matched: undefined,
      force: true
    })
  })
}

